import React, { FC } from 'react';
import { JSX } from 'react/jsx-runtime';
import { useStoreState } from '../../../store/hooks';
import { StFlagIcon, StSwitchText, StSwitchWrapper } from './SwitchLanguage.style';
import IntrinsicElements = JSX.IntrinsicElements;

interface Props {
  translationFlag: string;
  translationCountry: string;
}

const SwitchLanguage: FC<Props> = ({ translationFlag, translationCountry }) => {
  const currentTranslation = useStoreState((state) => state.intl.locale);

  const onTranslateClick = () => {
    const widget = document.querySelector<HTMLElement>(
      'sgwt-account-center'
    ) as IntrinsicElements['sgwt-account-center'];
    if (widget?.changeLanguage) {
      widget.changeLanguage(currentTranslation === 'fr' ? 'en' : 'fr');
    }
  };

  return (
    <StSwitchWrapper onClick={onTranslateClick}>
      <StFlagIcon data-testid="translationFlag" src={translationFlag} alt="country flag" />
      <StSwitchText>{translationCountry}</StSwitchText>
    </StSwitchWrapper>
  );
};

export default SwitchLanguage;
